import { useState, useEffect } from 'react';

interface UseToggleUserInfoReturn {
    maskedUserId: string;
    toggleMask: () => void;
}

const useToggleUserInfo = (userId: string): UseToggleUserInfoReturn => {
    const [isMasked, setIsMasked] = useState<boolean>(false);

    useEffect(() => {
        // Read the variable from localStorage when the component mounts
        const localStorageValue = window.localStorage.getItem('shownUserInfo') === 'true';
        setIsMasked(!localStorageValue);
    }, []);

    const toggleMask = () => {
        // Toggle the masking state and update the localStorage variable
        setIsMasked((prevIsMasked) => {
            const newIsMasked = !prevIsMasked;
            localStorage.setItem('hideUserId', newIsMasked.toString());
            return newIsMasked;
        });
    };

    const maskedUserId = isMasked ? '*****' : userId;

    return {
        maskedUserId,
        toggleMask,
    };
};

export default useToggleUserInfo;
